import * as types from 'actions/action-types';

var initialState = {
	quote: null,
	quote_pending: false,
	quote_save_pending: false,
	quote_unsubscribe: false,

	quote_activity_log: [],
    quote_activity_log_pending: false,
    quote_activity_log_save_pending: false,
    quote_activity_log_fulfilled: false,
    quote_activity_log_unsubscribe: false,


	quote_attachments: [],
    quote_attachments_pending: false,
    quote_attachments_save_pending: false,
    quote_attachments_fulfilled: false,
    quote_attachments_unsubscribe: false,

	quotes: [],
	quotes_pending: false,
	quotes_save_pending: false,
	quotes_unsubscribe: false,

	quotes_dashboard: [],
	quotes_dashboard_pending: false,
	quotes_dashboard_save_pending: false,
	quotes_dashboard_unsubscribe: false,

	quotes_open: [],
	quotes_open_pending: false,
	quotes_open_save_pending: false,
	quotes_open_unsubscribe: false,

	quote_approved: null,
	quote_approved_pending: false,
	quote_approved_save_pending: false,
	quote_approved_unsubscribe: false,

	options_selected: [],
	options_selected_pending: false,
	options_selected_save_pending: false,
	options_selected_unsubscribe: false,

	quote_items: [],
	quote_items_pending: false,
	quote_items_unsubscribe: false,
};

const quotesReducer = (state = initialState, action) => {

	switch (action.type) {
		case types.QUOTE + '_PENDING': pending('quote'); break;
		case types.QUOTE + '_SAVE_PENDING': save_pending('quote'); break;
		case types.QUOTE + '_FULFILLED': fulfilled('quote'); break;

		case types.QUOTE + '_' + types.ACTIVITY_LOG + '_PENDING': pending('quote_activity_log'); break;
        case types.QUOTE + '_' + types.ACTIVITY_LOG + '_FULFILLED': fulfilled('quote_activity_log'); break;
        case types.QUOTE + '_' + types.ACTIVITY_LOG + '_CLEAR': clear('quote_activity_log', []); break;

		case types.QUOTE + '_' + types.ATTACHMENTS + '_PENDING': pending('quote_attachments'); break;
        case types.QUOTE + '_' + types.ATTACHMENTS + '_SAVE_PENDING': save_pending('quote_attachments'); break;
        case types.QUOTE + '_' + types.ATTACHMENTS + '_FULFILLED': fulfilled('quote_attachments'); break;
        case types.QUOTE + '_' + types.ATTACHMENTS + '_SAVE_FULFILLED': save_fulfilled('quote_attachments'); break;
        case types.QUOTE + '_' + types.ATTACHMENTS + '_CLEAR': clear('quote_attachments', []); break;

		case types.QUOTES + '_PENDING': pending('quotes'); break;
		case types.QUOTES + '_SAVE_PENDING': save_pending('quotes'); break;
		case types.QUOTES + '_FULFILLED': fulfilled('quotes'); break;
		case types.QUOTES + '_CLEAR': state = { ...state, quotes: [] }; break;

		case types.QUOTES_DASHBOARD + '_PENDING': pending('quotes_dashboard'); break;
		case types.QUOTES_DASHBOARD + '_SAVE_PENDING': save_pending('quotes_dashboard'); break;
		case types.QUOTES_DASHBOARD + '_FULFILLED': fulfilled('quotes_dashboard'); break;
		case types.QUOTES_DASHBOARD + '_CLEAR': clear('quotes_dashboard', []); break;

		case types.QUOTES_OPEN + '_PENDING': pending('quotes_open'); break;
		case types.QUOTES_OPEN + '_SAVE_PENDING': save_pending('quotes_open'); break;
		case types.QUOTES_OPEN + '_FULFILLED': fulfilled('quotes_open'); break;
		case types.QUOTES_OPEN + '_CLEAR': state = { ...state, quotes_open: [] }; break;
		
		case types.QUOTE_APPROVED + '_PENDING': pending('quote_approved'); break;
		case types.QUOTE_APPROVED + '_SAVE_PENDING': save_pending('quote_approved'); break;
		case types.QUOTE_APPROVED + '_FULFILLED': fulfilled('quote_approved'); break;

		case types.QUOTE_ITEMS + '_PENDING': pending('quote_items'); break;
		case types.QUOTE_ITEMS + '_FULFILLED': fulfilled('quote_items'); break;
		case types.QUOTE_ITEMS + '_CLEAR': state = { ...state, quote_items: [] }; break;

		default: break;
	}

	return state;

	function pending(table) {
		state = {
			...state,
			[table + '_pending']: true,
		};
	}
	function fulfilled(table) {
		state = {
			...state,
			[table]: action.data,
			[table + '_pending']: false,
			[table + '_save_pending']: false,
            ...(action.unsubscribe) ? { [table + '_unsubscribe']: (action.unsubscribe) } : {},
		};
	}
	function save_pending(table) {
		state = {
			...state,
			[table + '_save_pending']: true,
		};
	}
	function save_fulfilled(table) {
		state = { ...state,
			[table + '_save_pending']: false,
		};
	}
    function clear(table, value) {
        state = {
            ...state,
            [table]: value,
        };
    }
};
export default quotesReducer;


